<template>
	<div class="gold">
		<!-- banner -->
		<div class="banner">
			<el-carousel :height="bannerHeight+'px'">
				<el-carousel-item v-for="(item, index) in sliders" :key="index">
					<img style="width:100%;height: auto" :src="item.img" class="slider_img">
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="gold-con">
			<div class="glod-charts">
				<div class="charts">
					<div class="gold-price">
						<div class="gold-l">
							<p class="f24">实时金价</p>
							<p class="red">参考上海黄金交易所AU9999金价</p>
						</div>
						<div class="gold-r">{{ actPrice }}/克</div>
					</div>
					<div ref="chartRef" id="main"></div>
				</div>
				<div class="recycling">
					<p class="f24">黄金回收/克</p>
					<p class="f12 red">请在下方填写您要回收的黄金克重</p>
					<div class="price">
						<img src="../../static/gold/price-icon.png" alt="" />
						<input focus="true" class="price-ipt" type="digit" v-model="num" @input="oninputDifferenc"
							:maxlength="moneyMaxLeng" placeholder="请输入黄金克重"/>
						<span class="f20">克</span>
					</div>
					<div class="count">
						<p class="flex-1">实时金价：<span class="red">{{ actPrice }}</span>/克（以实时价格为准）</p>
						<p class="c-6">服务费限时优惠：<span class="red">{{ servicePrice }}</span>元/克</p>
					</div>
					<div class="count">
						<p class="flex-1 f24">预估回收价：</p>
						<p class="red f36">{{ totalPrice > 0 ? totalPrice : '0' }}元</p>
					</div>
					<div class="submit-btn">
						<p class="gold-phone">
							<img class="mr-10" src="../../static/gold/apply-icon2.png" alt="" />
							<input v-model="userPhone" class="advice-ipt" type="number" placeholder="请输入手机号" />
						</p>
						<p class="gold-btn" @click="onsubmit">提交换钱</p>
					</div>
				</div>
			</div>
			<div class="glod-list">
				<div class="glod-item" v-for="(item, i) in glodArr" :key="i">
					<img class="mr-10" :src="item.icon" alt="" />{{ item.name }}
				</div>
			</div>
		</div>
		<Dialog :centerDialogVisible="centerDialogVisible" @close="close"></Dialog>
	</div>
</template>

<script>
	import Dialog from '@/components/Dialog.vue'
	import * as echarts from 'echarts';
	let chart = null;
	export default {
		components: {Dialog},
		data () {
			return {
				centerDialogVisible: false,
				userPhone: '',
				socket: null,
				actPrice: '', // 金价
				servicePrice: '', // 服务费
				// 容器的高度
				bannerHeight: 0,
				// 瀏覽器寬度
				screeWith: 0,
				sliders: [],
				glodArr: [{
					icon: require('../../static/gold/icon1.png'),
					name: '线上下单'
				},{
					icon: require('../../static/gold/icon2.png'),
					name: '前往门店'
				},{
					icon: require('../../static/gold/icon3.png'),
					name: '当面检测'
				},{
					icon: require('../../static/gold/icon4.png'),
					name: '现场收钱'
				}],
				num: '',
				moneyMaxLeng: 8,
				xList: [],
				yList: [],
				option: {
					tooltip: {
						trigger: 'axis', // 触发类型，默认数据项触发，可选为：'item' | 'axis' | 'none'
						axisPointer: {
							type: 'cross', // 默认为直线，可选为：'line' | 'shadow'
							label: {
								backgroundColor: '#6a7985'
							}
						}
					},
					xAxis: {
						type: 'category', // 或 'category' 对于离散数据
						data: [],
						axisLabel: {
							show: true, // 显示刻度标签
							interval: 0, // 自动计算刻度间隔
							showMinLabel: true, // 显示最小刻度标签
							showMaxLabel: true, // 显示最大刻度标签
						},
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						// 默认为true，折线图+x轴category左右两侧会留白，这边设置为false
						boundaryGap: false,
						boundaryGap: ['50%', '50%'] // 调整这个值来改变距离
					},
					yAxis: {
						type: 'value',
						min: 0.00,
						max: 0.00,
						axisLabel: {
							formatter: function(value, index) {
								return value.toFixed(2)
							},
						},
						data: [{
							textStyle: {
								color: '#333333',
								fontSize: 10,
							}
						}],
						splitLine: {
							lineStyle: {
								// 设置背景横线
								color: '#EEEEEE'
							}
						},
					},
					series: [
					    {
						  name: '',
					      data: [820, 932, 901, 934, 1290, 1330, 1320],
					      type: 'line',
						  smooth: true, // 平滑曲线
						  itemStyle: { // 设置折线点的样式
							  opacity: 0,
							  color: '#CF2427' // 设置折线点的颜色
						  },
						  lineStyle: { // 设置折线的样式
							  
							  color: '#CF2427' // 设置折线的颜色
						  },
					      areaStyle: {
							  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								  offset: 0,
								  color: '#CF2427' // 起始颜色
							  }, {
								  offset: 1,
								  color: '#ffffff' // 结束颜色
							  }])
						  }
					    }
					]
				}
			}
		},
		computed: {
			totalPrice: function() {
				let sum = ((parseFloat(this.actPrice) - parseFloat(this.servicePrice)) * Number(this.num)).toFixed(2)
				return sum;
			}
		},
		created() {
			this.getGlodPrice()
			this.socket = new WebSocket('wss://app.qulego8.com/api/sy/socket/app/yunxiaodang');
			this.socket.onopen = (event) => {
				console.log('WebSocket is open now.');
			};
			this.socket.onmessage = (res) => {
				let data = {};
				data = JSON.parse(res.data)
				if (data.code == '100') {
					this.actPrice = data.actPrice
					this.servicePrice = data.servicePrice
				}
				if (data.code == '300') {
					this.getServerData(data, 1)
				}
			};
			this.socket.onerror = (event) => {
				console.error('WebSocket error:', event);
			};
			this.socket.onclose = (event) => {
				console.log('WebSocket is closed now.');
			};
		},
		mounted() {
			this.initChart();
			this.sliders = [{
				img: require("../../static/gold/banner.png")
			}],
			// 首次加載時，初始化高度
			this.screeWith = window.innerWidth
			this.bannerHeight = 300 / 1920 * this.screeWith
			// 窗口大小發生變化
			window.onresize = () => {
				this.screeWith = window.innerWidth
				this.bannerHeight = 300 / 1920 * this.screeWith
			}
		},
		methods: {
			close(flag) {
				this.centerDialogVisible = flag
			},
			oninputDifferenc(e) {
				this.$nextTick(() => {
					let val = e.target.value.toString();
					val = val.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
					val = val.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
					val = val.replace(/^0+\./g, '0.');
					val = val.match(/^0+[1-9]+/) ? val = val.replace(/^0+/g, '') : val
					val = (val.match(/^\d*(\.?\d{0,2})/g)[0]) || ''
					if (val.includes(".")) {
						let numDian = val.toString().split(".")[1].length;
						if (numDian === 2) {
							this.moneyMaxLeng = val.length;
						}
					} else {
						this.moneyMaxLeng = 8;
					}
				});
			},
			async getGlodPrice() {
				let res = await this.util.request({
					url: `/sy/getGoldQuest`,
					method: 'GET',
					data: {},
				});
				if (res.status === 200) {
					this.actPrice = res.data.actPrice
					this.servicePrice = res.data.servicePrice
					this.xList = res.data.xList
					this.yList = res.data.yList
					this.getServerData(res.data, 2)
				}
			},
			async initChart() {
				const chartDom = document.getElementById('main');
				chart = echarts.init(chartDom);
			},
			async getServerData(data, type) {
				this.option.yAxis.min = data.low/1 - 10
				this.option.yAxis.max = data.high/1 + 10
				this.option.yAxis.interval = (Number(data.high/1 + 10) - Number(data.low/1 -10)) / 5;
				
				if (type == 2) {
					this.option.xAxis.data = data.xList
					this.option.series[0].data = data.yList
					this.option.xAxis.axisLabel.interval = Math.ceil(this.xList.length / 3);	
				} 
				
				if (type == 1) {
					this.xList.push(data.time);
					this.yList.push(data.price);
					this.option.xAxis.data = this.xList.map(item => (item))
					this.option.series[0].data = this.yList.map(item => (item))
					this.option.xAxis.axisLabel.interval = Math.ceil(this.xList.length / 3);
					chart.setOption(this.option,false)
				} else {
					const chartDom = document.getElementById('main');
					chart = echarts.init(chartDom);
					chart.setOption(this.option)
				}
			},
			onsubmit() {
				if (this.userPhone == '') {
					this.$message.error('请输入手机号');
					return false
				}
				let res = this.util.request({
					url: `/sy/getYunPuWebsite/submitFrom`,
					method: 'POST',
					data: {
						userPhone: this.userPhone,
						clueType: 1,
					},
				}).then(res => {
					if (res.status === 200) {
						this.centerDialogVisible = true
					}
				}).catch(error => {
					this.$message.error(error);
				});
			}
		}
	}
</script>

<style scoped>
	/* 今日金价 */
	.gold {}

	.gold-con {
		width: 1200px;
		margin: 0 auto;
		padding-top: 60px;
		padding-bottom: 60px;
	}
	.glod-charts {
		display: flex;
		justify-content: space-between;
	}
	.charts {
		width: 49%;
		background: #FFFFFF;
		border-radius: 8px;
		margin-right: 20px;
	}
	.gold-price {
		display: flex;
		align-items: center;
		padding: 30px 40px 0;
	}
	.gold-l {
		flex: 1;
		font-weight: 600;
		font-size: 12px;
	}
	.gold-r {
		font-weight: 600;
		font-size: 38px;
		color: #cf2427;
	}
	#main {
		width: 590px;
		height: 320px;
		background: #FFFFFF;
		border-radius: 8px;
	}
	.recycling {
		width: 49%;
		padding: 30px 40px;
		height: 416px;
		background: #FFFFFF;
		border-radius: 8px;
		font-weight: 600;
		box-sizing: border-box;
	}
	.price {
		display: flex;
		align-items: center;
		margin-top: 24px;
		margin-bottom: 20px;
		padding-bottom: 6px;
		border-bottom: 1px solid #EEEEEE;
	}
	.price-ipt {
		flex: 1;
		padding-left: 20px;
		padding-right: 20px;
		height: 66px;
		line-height: 66px;
		font-weight: bold;
		font-size: 30px;
		color: #CF2427;
	}
	.price-ipt::placeholder {
		font-weight: 400;
		font-size: 20px;
		color: #666;
	}
	.count {
		display: flex;
		align-items: center;
		margin-bottom: 30px;
		.flex-1 {
			flex: 1;
		}
	}
	.submit-btn {
		display: flex;
		align-items: center;
	}
	.gold-phone {
		flex: 1;
		display: flex;
		align-items: center;
		height: 44px;
		line-height: 44px;
		border-radius: 22px;
		border: 1px solid #cf2427;
		padding: 0 10px;
		margin-right: 23px;
		font-size: 14px;
		color: #999999;
	}
	.gold-phone .mr-10 {
		margin-right: 10px;
	}
	.gold-btn {
		flex: 1;
		height: 44px;
		line-height: 44px;
		background: #cf2427;
		border-radius: 22px;
		text-align: center;
		font-size: 16px;
		color: #FFFFFF;
	}
	.glod-list {
		width: 1200px;
		margin: 0 auto;
		margin-top: 20px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.glod-item {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 285px;
		height: 80px;
		background: #FFFFFF;
		border-radius: 8px;
	}
	.glod-item .mr-10 {
		margin-right: 10px;
	}
	.f24 {
		font-size: 24px;
	}
	.f36 {
	    font-size: 36px;
	}
	.red {
		color: #cf2427;
	}
</style>


// WEBPACK FOOTER //
// src/view/gold.vue